// The one place that picks the price wording by MK_PRICING_PUBLIC (ADR-0048): price.* (ADR-0045) when on,
// priceFree.* (the ADR-0044 wording) when off. Every page, the JSON-LD and the /vs rows read the price through here.
// {clients} in a price text is CLIENTS_WORD («three», ADR-0062, BL-194).
import { t } from "./i18n";
import { PRICING_PUBLIC } from "./flags";
import { CLIENTS_WORD } from "./lib";

export type PriceText = "short" | "long" | "row" | "faqQ" | "faqA";

export function priceText(key: PriceText): string {
  return t(PRICING_PUBLIC ? `price.${key}` : `priceFree.${key}`, { clients: CLIENTS_WORD });
}
